import { Modal, Image } from "antd";


const ImageViewerModal = ({  handleClose, isModalVisible, mainSrc}) => {

return (
    <div>
      {/* Modal with full image */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={handleClose}
        centered
        style={{ backgroundColor: "transparent" }}
      >
        <Image
          src={mainSrc}
          width="100%"
          preview={false}
          style={{ maxHeight: '80vh', objectFit: 'contain', borderRadius: '10px' }}
          alt={mainSrc}
        />
      </Modal>
    </div>
  );
};

export default ImageViewerModal;
